import { Injectable } from '@angular/core';
import { MyAccountActions, PersonalManagerApiService } from '@my-account/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AuthActions } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class PersonalManagersListEffects {
  loadPersonalManagers$: Observable<
    | MyAccountActions.LoadPersonalManagersList
    | MyAccountActions.LoadPersonalManagersListSuccess
    | MyAccountActions.LoadPersonalManagersListFail
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(MyAccountActions.LOAD_PERSONAL_MANAGERS_LIST),
      map((action: MyAccountActions.LoadPersonalManagersList) => action),
      switchMap(() =>
        this.personalManagerApiService.loadList().pipe(
          map((managersList) => new MyAccountActions.LoadPersonalManagersListSuccess(managersList)),
          catchError((error: unknown) => of(new MyAccountActions.LoadPersonalManagersListFail(error))),
        ),
      ),
    ),
  );

  resetPersonalManagersList$: Observable<MyAccountActions.LoadPersonalManagersListReset> = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.LOGOUT),
      map(() => new MyAccountActions.LoadPersonalManagersListReset()),
    ),
  );

  reloadManagerList$: Observable<MyAccountActions.LoadPersonalManagersList> = createEffect(() =>
    this.actions$.pipe(
      ofType(
        MyAccountActions.APPROVE_PERSONAL_MANAGER_SUCCESS,
        MyAccountActions.REVOKE_PERSONAL_MANAGER_SUCCESS,
        MyAccountActions.DELETE_PERSONAL_MANAGER_SUCCESS,
      ),
      map(() => new MyAccountActions.LoadPersonalManagersList()),
    ),
  );

  constructor(
    private actions$: Actions,
    private personalManagerApiService: PersonalManagerApiService,
  ) {}
}
